import { Sparklines, SparklinesLine } from "react-sparklines";

interface ForexContainerProps {
    pair: string;
    percentage: string;
    value: number;
    data?: number[];
}

export default function ForexContainer({ pair, percentage, value, data = [5, 10, 5, 20, 8, 15, 11, 13, 17, 22] }: ForexContainerProps) {
    const getColor = (percentage: string) => {
        if (percentage.startsWith('-')) return 'red';
        if (percentage.startsWith('+')) return 'green';
        return 'gray';
    };

    const color = getColor(percentage);

    return (
        <div className="flex flex-col items-center justify-center rounded-lg p-2 bg-none border border-gray-400">
            <div className="flex items-center gap-x-2">
                <p className="text-white text-md">{pair}</p>
                <p className={`text-${color}-500 text-md`}>{percentage}</p>
            </div>

            <div className="flex items-center gap-x-2 my-2">
                <p className="text-gray-400 text-xs">Last 24h</p>

                <div className="w-[50px] h-[10px]">
                    <Sparklines data={data} width={50} height={10}>
                        <SparklinesLine color={color} />
                    </Sparklines>
                </div>

                <p className="text-white text-xs">{value}</p>
            </div>
        </div>
    );
}